import { createSelector } from "reselect";

import { RootState } from "redux/reducers/rootReducer";

const getCmsState = (state: RootState) => state.cms;

export const getEmailSignupCopy = createSelector([getCmsState], (state) => [
  state.footer.newsletter.header,
  state.footer.newsletter.subCopy,
]);
